import { render, staticRenderFns } from "./task-summary.vue?vue&type=template&id=051fc528&scoped=true"
import script from "./task-summary.vue?vue&type=script&lang=js"
export * from "./task-summary.vue?vue&type=script&lang=js"
import style0 from "./task-summary.vue?vue&type=style&index=0&id=051fc528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051fc528",
  null
  
)

export default component.exports